import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'feature.dashboard.title',
    defaultMessage: 'Home',
  },
  walletCardTitle: {
    id: 'bannerCookiePolicy.walletCardTitle',
    defaultMessage: 'Portafoglio',
  },
  marketplaceButton: {
    id: 'feature.dashboard.marketplaceButton',
    defaultMessage: 'Vai ad Azimut Marketplace',
  },
});
